<template>
  <v-menu
      :close-on-click="false"
      :close-on-content-click="false"
      offset-y
      bottom
      left
      allow-overflow
      tile
      content-class="elevation-0 tile-corner"
      v-model="settingsVisible"
      v-hotkey="keymap"
  >
    <template v-slot:activator="{ on }">
      <v-card tile flat height="100%" class="d-flex align-center theme-background">
        <v-btn text tile min-width="46px" width="46px" class="pa-0 ma-0" height="100%" @click="handleTogglePause" :disabled="gamefinished||clockDisable">
          <v-icon :style="{color: $vuetify.theme.dark ? '#ffffff' : '#23C373'}">{{isPaused ? 'mdi-play' : 'mdi-pause'}}</v-icon>
        </v-btn>
        <div class="px-1 px-md-3 timer-text">
          <span v-if="minutes<10">0</span>{{minutes}}<span class="blink" :class="blink ? 'grey-blink' : ''">:</span><span v-if="seconds<10">0</span>{{seconds}}
        </div>
        <v-btn text tile v-on="on" min-width="46px" width="46px" height="100%" @click="setTmpTime" class="btn-setting theme-border pa-0" :disabled="gamefinished||settingsDisable">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 21 21"
               :style="{fill: settingsDisable ? ($vuetify.theme.dark ? '#68696f' : '#bdbdbd') : ($vuetify.theme.dark ? '#ffffff' : '#23C373')}">
            <g>
              <path d="M19.977 8.448l-2.248-.369c-.16-.558-.384-1.096-.667-1.606l1.303-1.824c.17-.239.143-.566-.064-.773l-1.697-1.697c-.207-.207-.534-.234-.773-.064l-1.824 1.303c-.51-.283-1.048-.507-1.606-.667L12.032.503C11.984.213 11.734 0 11.44 0h-2.4c-.294 0-.544.213-.592.503L8.079 2.75c-.558.16-1.096.384-1.606.667L4.649 2.115c-.239-.17-.566-.143-.773.064L2.179 3.876c-.207.207-.234.534-.064.773l1.303 1.824c-.283.51-.507 1.048-.667 1.606l-2.248.369C.213 8.496 0 8.746 0 9.04v2.4c0 .294.213.544.503.592l2.248.369c.16.558.384 1.096.667 1.606l-1.303 1.824c-.17.239-.143.566.064.773L3.876 18.3c.207.207.534.234.773.064l1.824-1.303c.51.283 1.048.507 1.606.667l.369 2.248c.048.29.298.503.592.503h2.4c.294 0 .544-.213.592-.503l.369-2.248c.558-.16 1.096-.384 1.606-.667l1.824 1.303c.239.17.566.143.773-.064l1.697-1.697c.207-.207.234-.534.064-.773l-1.303-1.824c.283-.51.506-1.048.667-1.606l2.248-.369c.29-.048.503-.298.503-.592v-2.4c0-.294-.213-.544-.503-.592zm-.697 2.482l-2.13.35c-.24.04-.432.22-.487.456-.163.702-.44 1.37-.824 1.986-.129.206-.12.469.02.666l1.234 1.727-.978.978-1.727-1.233c-.197-.141-.46-.15-.666-.021-.616.384-1.284.66-1.985.824-.237.055-.418.247-.457.487l-.35 2.13H9.55l-.35-2.13c-.04-.24-.22-.432-.456-.487-.702-.163-1.37-.44-1.986-.824-.206-.129-.468-.12-.666.02l-1.727 1.234-.978-.978 1.233-1.727c.141-.197.15-.46.021-.666-.384-.616-.66-1.284-.824-1.986-.055-.236-.247-.417-.487-.456l-2.13-.35V9.55l2.13-.35c.24-.04.432-.22.487-.456.163-.702.44-1.37.824-1.986.129-.206.12-.469-.02-.666L3.386 4.365l.978-.978L6.092 4.62c.197.141.46.15.666.021.616-.384 1.284-.66 1.986-.824.236-.055.417-.247.456-.487l.35-2.13h1.38l.35 2.13c.04.24.22.432.456.487.702.163 1.37.44 1.986.824.206.129.469.12.666-.02l1.727-1.234.978.978-1.233 1.727c-.141.197-.15.46-.021.666.384.616.66 1.284.824 1.986.055.236.247.417.487.456l2.13.35v1.38z"
                    transform="translate(0 .5)"/>
              <path d="M10.24 4.84c-2.978 0-5.4 2.422-5.4 5.4s2.422 5.4 5.4 5.4 5.4-2.422 5.4-5.4-2.422-5.4-5.4-5.4zm0 9.6c-2.316 0-4.2-1.884-4.2-4.2 0-2.316 1.884-4.2 4.2-4.2 2.316 0 4.2 1.884 4.2 4.2 0 2.316-1.884 4.2-4.2 4.2z"
                    transform="translate(0 .5)"/>
              <path d="M11.864 11.016L10.84 9.99V7.84c0-.331-.269-.6-.6-.6-.331 0-.6.269-.6.6V10.242c0 .163.069.315.176.422l1.2 1.2c.234.235.614.235.848 0 .235-.234.235-.614 0-.848z"
                    transform="translate(0 .5)"/>
            </g>
          </svg>
        </v-btn>
      </v-card>
    </template>
    <v-card tile flat class="timeModal theme-background theme-border">
      <v-container>
        <v-row no-gutters>
          <v-col cols="12" sm="5">
            <v-btn depressed tile width="100%" class="transparent"
                   @click="increaseTmpMinutes()">
              <v-icon style="font-size: 28px;">mdi-chevron-up</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2"></v-col>
          <v-col cols="12" sm="5">
            <v-btn depressed tile width="100%" class="transparent"
                   @click="increaseTmpSeconds()">
              <v-icon style="font-size: 28px;">mdi-chevron-up</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters height="70px" align="center" justify="center">
          <v-col cols="12" sm="5">
            <v-card class="text-center pa-2 display-1 transparent" tile flat>
              <span v-if="tmpMinutes<10">0</span>{{tmpMinutes}}
            </v-card>
          </v-col>
          <v-col cols="12" sm="2">
            <v-card class="text-center pa-2 display-1 colon theme-background" tile flat>:</v-card>
          </v-col>
          <v-col cols="12" sm="5">
            <v-card class="text-center pa-2 display-1 transparent" tile flat>
              <span v-if="tmpSeconds<10">0</span>{{tmpSeconds}}
            </v-card>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12" sm="5">
            <v-btn depressed tile width="100%" class="transparent"
                   @click="decreaseTmpMinutes()">
              <v-icon style="font-size: 28px;">mdi-chevron-down</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="12" sm="2"></v-col>
          <v-col cols="12" sm="5">
            <v-btn depressed tile width="100%" class="transparent"
                   @click="decreaseTmpSeconds()">
              <v-icon style="font-size: 28px;">mdi-chevron-down</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <v-card tile align-center>
      <v-card-actions class="justify-center pa-0 ma-0">
        <v-btn class="pa-0 ma-0 setting-bottom-button-left theme-back theme-border text-capitalize" width="50%"
               min-height="45px" tile depressed @click="closeSettings">Mégsem
        </v-btn>
        <v-btn class="pa-0 ma-0 setting-bottom-button-right theme-back theme-border text-capitalize" width="50%"
               min-height="45px" tile depressed @click="saveTimeChange">Mentés
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>

<script>
var debug = require('debug')('MKSZ:clock');
import eventBus from '@/eventBus';
import { hotkeys } from '@/plugins/hotkeys';
import CONSTANTS from '@/constants';
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';

import busListeners from "@/mixins/busListeners";
import { getChronoOrder } from '@/utils/periodOrder';

export default {
    mixins: [busListeners],
  name: "Clock",
  props: {
    clockDisable: Boolean,
    settingsDisable: Boolean,
    hotkeys: Boolean,
    period: String,
    gamedata: Object,
    gamefinished: Boolean
  },
  data: () => ({
    currentSection: '1',
    settingsVisible: false,
    blink: false,
    tmpMinutes: 0,
    tmpSeconds: 0,
    blocking: false,
  }),
  computed: {
    ...mapState('clock', ['minutes', 'seconds']),
    ...mapGetters('clock', ['isPaused', 'getDisplayTime']),

    keymap: function () {
      let self = this;
      if (!this.hotkeys) {
        return {};
      }

      return {
        [hotkeys['startPause']]: this.handleTogglePause,
      }
    },
  },
  methods: {
    // JAVÍTÁS (79. tétel - 32021424205): a CR-en egy KORÁBBI, már lejátszott
    // periódusra való visszaváltáskor (pl. "Mérkőzés vége" -> "II. félidő") az
    // óra eddig a periódus ELEJÉRE (30:00) állt, mert a setClockToPeriod()
    // nullázza a periódusbeli időt. Egy hiányzó esemény pótlásakor ez rossz
    // időt (30:00) adott - a 32021424205-ös meccsen így került háromszor egy
    // hetes gól 30:00-ra, és minden későbbi esemény állása eltolódott.
    // Visszaváltáskor most ott folytatódik az óra, ahol abban a periódusban a
    // rögzítés tartott: a periódus utolsó (nem törölt) eseményénél, legfeljebb
    // a periódus végénél. Előre váltáskor, illetve ha a periódusban még nincs
    // esemény, a viselkedés változatlan (a periódus eleje).
    getResumeSecondsForPeriod: function (oldSection, newSection) {
      if (!this.isRoute('report') || oldSection === undefined || oldSection === null) return 0;
      const isStrand = this.gamedata && this.gamedata.rule === 'STRAND';
      if (getChronoOrder(newSection, isStrand) >= getChronoOrder(oldSection, isStrand)) return 0;

      const periodData = this.$store.getters['game/getPeriodData'](newSection);
      if (!periodData || this.$store.getters['game/isPassivePeriod'](newSection)) return 0;
      const duration = parseInt(periodData.duration) || 0;
      if (duration <= 0) return 0;
      const start = parseInt(periodData.startat || 0);

      const timeline = this.$store.state.game.timelineData || [];
      let lastTotal = null;
      timeline.forEach(e => {
        if (!e || e.deleted === 1 || e.deleted === true) return;
        if (String(e.period) !== String(newSection)) return;
        const t = Number(e.totalGameTime);
        if (!isNaN(t) && (lastTotal === null || t > lastTotal)) lastTotal = t;
      });
      if (lastTotal === null) return 0;
      return Math.max(0, Math.min(lastTotal - start, duration));
    },
    ...mapActions('clock', ['initClock', 'togglePause']),
    ...mapMutations('clock', ['SET_TIME', 'SET_PAUSED']),

    clockLock(val) {
      if(this.isRoute('report')) {
        if (this.currentSection === '12') {
          val = false;
        }
        if (typeof val === 'undefined') {
          val = (this.minutes === 0 && this.seconds === 0);
        }

        if (this.period === '12' && this.gamedata.rule === "STRAND") {
          val = false;
        }

        this.blocking = val;
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.SHOTS, {component: 'time', value: val});
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.PENALTYSHOTS, {component: 'time', value: val});
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.LOSTBALLS, {component: 'time', value: val});
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.CARDS, {component: 'time', value: val});
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.COURT, {component: 'time', value: val});
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.GATE, {component: 'time', value: val});
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.PENALTIES, {component: 'time', value: val});
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.TEAM.B, val);
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.STAFF.B, val);
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.TEAM.A, val);
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.STAFF.A, val);
        eventBus.$emit(CONSTANTS.ACTIONS.DISABLE.TIMEOUTS, val);
      }
    },
    getMaxTime() {
      let self = this;
      let periodIndex = self.gamedata.periods.findIndex(item => item.value === self.currentSection);
      periodIndex = (periodIndex !== -1 && typeof periodIndex !== 'undefined') ? periodIndex : null;
      let type = periodIndex !== null ? self.gamedata.periods[periodIndex].type : null;

      let periodDuration = 0;
      if (type === "normal") {
        periodDuration = self.gamedata.period_length;
      } else if (type === "extended") {
        periodDuration = 5;
      }
      return Math.floor(window.stopwatch.getTrueTotalTime() / 60) + periodDuration;
    },
    checkTimeLimits() {
      let self = this;

      if (self.minutes >= self.getMaxTime()) {
        if (!self.isPaused) {
          window.stopwatch.stop();
          // JAVÍTÁS: a stopwatch.setTime() a periódushoz RELATÍV időt várja (ld. pl.
          // clock.js socketClockValue: periodTime = sentTimeInSeconds - getTrueTotalTime()),
          // a getMaxTime() viszont az ABSZOLÚT (meccs eleje óta eltelt) percet adja vissza.
          // A getTrueTotalTime()-ot le kell vonni belőle a relatív értékhez, különben a
          // stopper ezt még egyszer hozzáadja getTotalTime()-nál, és a kijelzett/tárolt idő
          // egy teljes félidőnyivel (pl. II. félidőnél 30 perccel) többet mutat a valóságosnál -
          // ez okozta a "90:00 a 60:00 helyett" hibát az órán ÉS az időstatisztikában is,
          // mivel mindkettő a window.stopwatch.getTotalTime()-ot olvassa.
          window.stopwatch.setTime((self.getMaxTime() * 60) - window.stopwatch.getTrueTotalTime());
          self.SET_PAUSED(true);
          self.SET_TIME({minutes: self.getMaxTime(), seconds: 0});

          eventBus.$emit(CONSTANTS.EVENTS.CLOCK.PAUSED);
          if (self.$route.meta.header === 'substitute') {
            eventBus.$emit(CONSTANTS.EVENTS.PERIOD.ENDS, self.currentSection);
          }
        }
        self.blink = false;
        self.changePause();
        self.syncClock();
      }

      if (!self.isPaused) {
        self.blink = !self.blink;
        if(self.minutes == self.getMaxTime()) {
          self.blink = false;
        }
      } else {
        self.blink = false;
      }

      eventBus.$emit(CONSTANTS.EVENTS.CLOCK.TICK, self.getDisplayTime);

      if (self.minutes <= self.getMaxTime()) {
        self.syncClock();
      }
    },
    changePause: function () {
      let periodIndex = this.gamedata.periods.findIndex(item => item.value === this.period);
      periodIndex = (periodIndex !== -1 && typeof periodIndex !== 'undefined') ? periodIndex : null;

      if(periodIndex !== null && ['zero', 'extendedzero'].includes(this.gamedata.periods[periodIndex].type)) {
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.SETTINGSDISABLE, true);
        this.blink = false;
      } else {
        if (this.isPaused) {
          this.blink = false;
          if (this.settingsDisable) {
            eventBus.$emit(CONSTANTS.EVENTS.CLOCK.SETTINGSDISABLE, false);
          }
        } else {
          if (!this.settingsDisable) {
            eventBus.$emit(CONSTANTS.EVENTS.CLOCK.SETTINGSDISABLE, true);
          }
        }
      }
    },
    syncClock: function () {
      // JAVÍTÁS: user adatok elérése a connection modulból
      if (this.$store.state.connection &&
          this.$store.state.connection.user &&
          this.$store.state.connection.user.type === 'cr') {

        window.vueio.emit(CONSTANTS.SOCKET.ACTIONS.SYNC, {
          type: 'clock_value',
          content: {
            minutes: this.minutes,
            seconds: this.seconds,
            clientTime: window.ts.now(),
            totaltime: window.stopwatch.getTrueTotalTime(),
            perioditems: window.stopwatch.perioditems,
          }
        });
      }
    },
    handleTogglePause: function () {
      let period = this.period;
      let periodIndex = this.gamedata.periods.findIndex(item => item.value === period);
      periodIndex = (periodIndex !== -1 && typeof periodIndex !== 'undefined') ? periodIndex : null;

      if((periodIndex !== null && this.gamedata.periods[periodIndex].duration > 0) || this.period === "12") {
        this.togglePause();

        if (this.isPaused) {
          // ...
        } else {
          eventBus.$emit(CONSTANTS.EVENTS.CLOCK.STARTED);
          eventBus.$emit(CONSTANTS.ACTIONS.STRAND.GOALKEEPER);
        }

        if (this.blocking) {
          this.clockLock(false);
        }
      }
    },
    stopClock: function () {
      if (!this.isPaused) {
        this.togglePause();
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.PAUSED);
        this.blink = false;
        this.changePause();
        this.syncClock();
      }
    },
    setTmpTime: function () {
      this.tmpMinutes = this.minutes;
      this.tmpSeconds = this.seconds;
      eventBus.$emit(CONSTANTS.EVENTS.CLOCK.DISABLE, !this.settingsVisible);
    },
    increaseTmpMinutes: function () {
      if (this.tmpMinutes >= this.getMaxTime()) { return; }
      if (((this.tmpMinutes + 1) === this.getMaxTime()) && this.tmpSeconds > 0) {
        this.tmpMinutes++;
        this.tmpSeconds = 0;
        return;
      }
      this.tmpMinutes++;
    },
    decreaseTmpMinutes: function () {
      if (this.tmpMinutes <= 0) { return; }
      this.tmpMinutes--;
    },
    increaseTmpSeconds: function () {
      if (this.tmpMinutes >= this.getMaxTime()) { return; }
      if (this.tmpSeconds >= 59) {
        this.tmpSeconds = 0;
        this.increaseTmpMinutes();
        return;
      }
      this.tmpSeconds++;
    },
    decreaseTmpSeconds: function () {
      if (this.tmpSeconds <= 0) {
        this.tmpSeconds = 59;
        this.decreaseTmpMinutes();
        return;
      }
      this.tmpSeconds--;
    },
    saveTimeChange: function () {
      let periodSeconds = (this.tmpMinutes * 60 + this.tmpSeconds) - window.stopwatch.getTrueTotalTime();
      if (periodSeconds < 0) periodSeconds = 0;
      window.stopwatch.setTime(periodSeconds);
      this.SET_TIME({ minutes: this.tmpMinutes, seconds: this.tmpSeconds });
      this.syncClock();
      this.closeSettings();
      eventBus.$emit(CONSTANTS.EVENTS.CLOCK.CHANGED, this.minutes + ':' + this.seconds);
      this.clockLock();
    },
    closeSettings: function () {
      this.settingsVisible = false;
      eventBus.$emit(CONSTANTS.EVENTS.CLOCK.DISABLE, false);
    },
    isRoute(url) {
      return this.$route.meta.header === url;
    },
  },
  created() {
    let self = this;

    this.initClock();

    this.$busOn(CONSTANTS.EVENTS.LASTTIMELOAD, function (data) {
      // A logból kiderült az igazság: a data nem tartalmaz 'period'-ot gyökérszinten,
      // hanem egy 'last' objektumon belül van az utolsó esemény!
      let lastEvent = data.last || {};

      // Kinyerjük a valós periódust a lastEvent-ből (ha nincs, a Store-ból)
      let period = lastEvent.period || self.$store.state.game.currentPeriod || '1';
      self.$store.commit('clock/SET_PERIOD', period);

      // Kiszámoljuk az időt a HELYES félidőből
      let maxGametime = -1;
      if (self.$store.state.game && self.$store.state.game.timelineData) {
        let currentPeriodEvents = self.$store.state.game.timelineData.filter(e => String(e.period) === String(period));
        if (currentPeriodEvents.length > 0) {
          maxGametime = Math.max(...currentPeriodEvents.map(e => e.gametime || 0));
        }
      }

      // Kiszámoljuk a végleges időt (itt is a lastEvent.gametime kell a data.gametime helyett!)
      let finalTime = 0;
      if (maxGametime >= 0) {
        finalTime = maxGametime;
      } else {
        finalTime = lastEvent.gametime || 0;
      }

      const urlParams = new URLSearchParams(window.location.search);
      const isCR = urlParams.get('felulet') === 'JEGYZOKONYV' || window.usertype === 'report' || self.isRoute('report');
      const isSub = window.usertype === 'sub' || urlParams.get('felulet') === 'SUB';

      const deriveFromLastEvent = () => {
        window.stopwatch.perioditems = self.gamedata.periods;
        window.stopwatch.setClockToPeriod(period);

        // JAVÍTÁS: a finalTime (lastEvent.gametime / maxGametime) MÁR a periódushoz
        // relatív idő, nem kumulatív - a "gametime" mező ezt jelenti mindenhol a
        // kódban (szemben a "totalGameTime"-mal, ami abszolút). A korábbi kód még
        // egyszer kivonta belőle a félidő kezdetét, ami szinte mindig negatív
        // eredményt adott (pl. II. félidőben: 217 - 1800 = -1583), ez pedig 0-ra
        // vágódott - emiatt ugrott vissza az óra RC után mindig a félidő elejére,
        // ahelyett hogy az utolsó rögzített eseménytől folytatódott volna.
        let periodSeconds = finalTime;
        if (periodSeconds < 0) periodSeconds = 0;
        window.stopwatch.setTime(periodSeconds);

        let m = Math.floor(window.stopwatch.getTotalTime() / 60);
        let s = Math.floor(window.stopwatch.getTotalTime() - m * 60);

        self.$store.commit('clock/SET_TIME', { minutes: m, seconds: s });
      };

      if (isCR) {
        if (!self.isPaused && window.hasInitialTimeLoaded) {
          self.syncClock();
        } else {
          window.hasInitialTimeLoaded = true;
          deriveFromLastEvent();
          self.syncClock();
        }
      } else if (isSub) {
        // JAVÍTÁS: a SUB felület órája/periódusa a CR-DMR párostól TELJESEN
        // FÜGGETLENÜL mozog (üzleti követelmény) - ezért a SUB sosem fogadhat el
        // CR-től érkező clock_value/clock_toggle push-ot (l. clock.js
        // socketClockValue/socketClockToggle isSub kizárása), és itt is csak
        // akkor deriváljuk újra a saját órájút az utolsó rögzített eseményből, ha
        // ez az első betöltés, VAGY ha a SUB saját periódusa ténylegesen
        // változott - a rutin 10 mp-es periodikus resync (ami ugyanezt a
        // LASTTIMELOAD eseményt váltja ki) nem ránthatja vissza feleslegesen a
        // már helyesen ketyegő SUB órát.
        const periodChanged = String(period) !== String(window.lastClockDerivedPeriod);
        if (!window.hasInitialTimeLoaded || periodChanged) {
          window.hasInitialTimeLoaded = true;
          window.lastClockDerivedPeriod = period;
          deriveFromLastEvent();
        }
      } else {
        // DMR: a CR órájának KELL követnie, függetlenül mindentől - ezért a DMR
        // az utolsó rögzített eseményből csak az ELSŐ betöltéskor deriválja a
        // saját óráját (amíg a CR-től még nem érkezett élő push). Utána
        // KIZÁRÓLAG a CR saját clock_value/clock_toggle push-ai (socketClockValue/
        // socketClockToggle, clock.js) vezérlik - ezt a derivációt itt UJRA
        // lefuttatni hiba volt: a rutin, ismétlődő LASTTIMELOAD (minden
        // reconnectnél ÉS a 10 mp-es periodikus resyncnél is lefut) minden
        // alkalommal visszarántotta a DMR óráját "az utolsó rögzített esemény"
        // időpontjára, függetlenül attól, hogy a CR órája azóta mennyit ketyegett
        // tovább - ez okozta a DMR/CR óraszétcsúszást hosszabb, sok reconnectes
        // teszt alatt.
        if (!window.hasInitialTimeLoaded) {
          window.hasInitialTimeLoaded = true;
          deriveFromLastEvent();
        }
      }

      if (isSub) {
        window.vueio.emit(CONSTANTS.SOCKET.ACTIONS.SYNC, {type: 'getStatus'});
      }
    });

    this.$busOn(CONSTANTS.ACTIONS.TOGGLE.PAUSE, function () {
      self.handleTogglePause();
    });

    this.$busOn(CONSTANTS.EVENTS.CLOCK.STOP, function () {
      self.stopClock();
    });

    this.$busOn(CONSTANTS.EVENTS.CLOCK.SET, function (minute, second) {
      self.blink = false;
      self.SET_TIME({ minutes: minute, seconds: second });
      window.stopwatch.setTime(minute * 60 + second);
      self.stopClock();
    });

    this.$busOn(CONSTANTS.EVENTS.PERIOD.CHANGED.CLOCK, function (section) {
      debug('period changed');
      if (!self.isPaused) {
        self.togglePause();
      }
      self.blink = false;
      // 79. tétel: visszaváltáskor az óra a periódus utolsó eseményénél folytatódik
      const resumeSeconds = self.getResumeSecondsForPeriod(self.currentSection, section);
      window.stopwatch.save(self.currentSection);
      window.stopwatch.setClockToPeriod(self.currentSection);
      if (resumeSeconds > 0) {
        window.stopwatch.setTime(resumeSeconds);
      }
      self.syncClock();

      window.setTimeout(() => {
        // JAVÍTÁS: a self.SET_TIME az ÓRÁN megjelenő, ABSZOLÚT (meccs eleje óta
        // eltelt) időt várja - a window.stopwatch.getTime() viszont a periódushoz
        // RELATÍV eltelt időt adja vissza (ami közvetlenül a periódusváltás után,
        // a setClockToPeriod() miatt, gyakorlatilag mindig ~0). Emiatt minden
        // periódusváltáskor egy pillanatra (majd itt, 100ms késleltetve) 00:00-ra
        // állt az óra, ahelyett hogy az új periódus KEZDŐ idejét (pl. "Rendes
        // játékidő vége" = 60:00) mutatta volna. Élénken futó (nem szüneteltetett)
        // periódusoknál ezt az órakijelző következő, folyamatos frissítése egy
        // képkockán belül felülírta, ezért nem tűnt fel - de olyan periódusnál,
        // ami rögtön szünetel (pl. "Rendes játékidő vége"), ez a hibás 00:00
        // érték maradt látható. A getTotalTime() adja az órán ténylegesen
        // megjelenítendő abszolút időt.
        let stopWatchTime = window.stopwatch.getTotalTime();
        let m = Math.floor(stopWatchTime / 60);
        let s = Math.floor(stopWatchTime - Math.floor(stopWatchTime / 60) * 60);
        self.SET_TIME({ minutes: m, seconds: s });
      }, 100);

      self.currentSection = section;
      window.stopwatch.stop();
      eventBus.$emit(CONSTANTS.EVENTS.CLOCK.PAUSED);
    });

    this.$busOn(CONSTANTS.EVENTS.CLOCK.PAUSED, function () {
      self.clockLock();
    });
    this.$busOn(CONSTANTS.EVENTS.CLOCK.CHECK, function () {
      self.clockLock();
    });
    this.$busOn(CONSTANTS.EVENTS.RECORD.CREATED, function () {
      self.clockLock();
    });
    this.$busOn(CONSTANTS.EVENTS.RECORD.CREATE, function (val) {
      self.clockLock(val ? false : undefined);
    });

    this.$busOn(CONSTANTS.EVENTS.CLOCK.CLOSE, function () {
      self.settingsVisible = false;
    });
  },
  watch: {
    minutes: function(newVal) {
      eventBus.$emit(CONSTANTS.EVENTS.CLOCK.MINUTECHANGED, newVal);
      this.checkTimeLimits();
    },
    seconds: function() {
      this.checkTimeLimits();
    },
    isPaused: function(isPaused) {
      this.changePause();
      if (isPaused) {
        eventBus.$emit(CONSTANTS.EVENTS.CLOCK.PAUSED);
      }
    }
  }
};
</script>

<style scoped>
.tile-corner {
  border-radius: 0 !important;
}

.btn-setting {
  border-style: solid;
  border-left-width: 1px;
  border-right-width: 1px;
  border-top-width: 0;
  border-bottom-width: 0;
}

.timer-text {
  /* Minimum 18px, ideálisan a képernyő szélesség 2%-a, de maximum 30px */
  font-size: clamp(18px, 2vw, 30px);
  font-weight: 900;
  white-space: nowrap;
  line-height: 1;
}

.setting-bottom-button-left {
  border-style: solid;
  border-top-width: 0 !important;
  border-left-width: 1px !important;
  border-right-width: 1px !important;
  border-bottom-width: 1px !important;
}

.setting-bottom-button-right {
  border-style: solid;
  border-top-width: 0 !important;
  border-left-width: 0 !important;
  border-right-width: 1px !important;
  border-bottom-width: 1px !important;
}

.timeModal {
  border-style: solid;
  border-width: 1px !important;
}

.colon {
  font-weight: 900 !important;
}

.blink {
  min-width: 10px;
  display: inline-block;
  text-align: center;
  transition: color 250ms;
}

.grey-blink {
  color: #757575 !important;
}
</style>
